import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '../common/shared.module';
import { LockScreenComponent } from './lock-screen/lock-screen.component';
import { ExitScreenComponent } from './exit-screen/exit-screen.component';
import { AudioCheckComponent } from './audio-check/audio-check.component';
import { PauseScreenComponent } from './pause-screen/pause-screen.component';
import { LoggerService } from '../../services/logger.service';
import { StartScreenPendingComponent } from './start-screen/start-screen-pending.component';
import { StartScreenPinComponent } from './start-screen/start-screen-pin.component';
import { StartScreenAudioCheckComponent } from './start-screen/start-screen-audio-check.component';
import { StartScreenMicrophoneCheckComponent } from './start-screen/start-screen-microphone-check.component';
import { StartScreenStartCodeComponent } from './start-screen/start-screen-start-code.component';
import { StartScreenWebComponent } from './start-screen/start-screen-web.component';

@NgModule({
  imports: [
    BrowserModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    LockScreenComponent,
    ExitScreenComponent,
    AudioCheckComponent,
    PauseScreenComponent,
    StartScreenPendingComponent,
    StartScreenPinComponent,
    StartScreenAudioCheckComponent,
    StartScreenMicrophoneCheckComponent,
    StartScreenStartCodeComponent,
    StartScreenWebComponent
  ],
  exports: [
    LockScreenComponent,
    ExitScreenComponent,
    PauseScreenComponent
  ],
  providers: [
    LoggerService
  ]
})
export class TdpModule { }



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/tdp/tdp.module.ts